export const redirect = (url: string, isNewWindow?: boolean): void => {
  isNewWindow ? window.open(url, '__blank')?.focus() : (window.location.href = url);
};
